/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

document.querySelectorAll(".showmore").forEach(function (p) {
  p.querySelector("a.show-more-btn").addEventListener("click", function () {
    p.classList.toggle("show");
    this.textContent = p.classList.contains("show") ? "- Show Less" : "+ Show More";
  });
});
